import React, { useEffect, useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import AdminTransactionsSidebar from "../components/AdminTransactionsSidebar";
import { paymentsActions, clientActions, salesBillingsActions, useSelector } from "inbooma-api";
import { Biscuit, FormatHelper, getAllUrlParams } from "../../../../utils";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import AdminTransactionsTopBar from "./AdminTransactionsTopBar";
import { isViewVisible } from "../../../../utils/ViewSettings";
import SortNav from "../../../components/SortNav";
import NextPageBtn from "../../../components/NextPageBtn";
import AdminTransactionsList from "./AdminTransactionList";
import moment from "moment";
import { $, _ } from "../../../../../vendor";
import Paginator from "../../../components/paginator";
import Loader from "../../../components/Loader";

const AdminTransactionsView = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const allUrlParamsClone = { ...allUrlParams };
  allUrlParams?.client_name !== undefined && delete allUrlParams.client_name;
  allUrlParams?.payment_method_name !== undefined && delete allUrlParams.payment_method_name;
  allUrlParams?.payment_status_name !== undefined && delete allUrlParams.payment_status_name;
  let language = Biscuit.get("user.lang").replace("-", "_");

  const [filter, setFilter] = useState({ complete: true });
  const [sort, setSort] = useState({
    sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "payment_date",
    direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "desc",
  });
  const paginationLimit = 100;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });
  const [walletsPending, setWalletsPending] = useState(false);
  const _wallets = useSelector((state) => state.payments_data.transactions);

  const [clientsPending, setClientsPending] = useState(false);
  const _clients = useSelector((state) => state.client_data.clients);
  const [clients, setClients] = useState(null);
  const [clientsArray, setClientsArray] = useState(null);
  const [locationName, setLocationName] = useState("");
  const [getCompletePending, setGetCompletePending] = useState(false);
  const _getComplete = useSelector((state) => state.sales_billings_data.getComplete);
  const [getComplete, setGetComplete] = useState(null);
  const [ready, setReady] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const _queryState = {
    timeStamp: 0,
    value: "",
  };

  useEffect(() => {
    if (walletsPending || clientsPending || getCompletePending) {
      return;
    }
    let requestFilter = { ...filter };
    props.dispatch(paymentsActions.getTransactionsResetData());
    requestFilter = { ...requestFilter, page: pagination.current_page };
    requestFilter = { ...requestFilter, limit: paginationLimit };
    requestFilter = { ...requestFilter, sort: sort.sort };
    requestFilter = { ...requestFilter, direction: sort.direction };
    requestFilter = { ...requestFilter, complete: true };
    requestFilter = { ...requestFilter, ...allUrlParams };
    props.dispatch(
      paymentsActions.getTransactions({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    props.dispatch(
      clientActions.getClients({
        token: Biscuit.get("token"),
        suffix: "",
        filter: {
          find: "completeSelect",
          fast: true,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    let begin = moment("1970-01-01").format("YYYY-MM-DD 23:59:59");
    let end = moment().format("YYYY-MM-DD 23:59:59");
    if (typeof filter.date_gte !== "undefined") {
      begin = filter.date_gte;
    }
    if (typeof filter.date_lte !== "undefined") {
      end = filter.date_lte;
    }
    let newFilter = {
      from: begin,
      to: end,
    };
    if (typeof filter.client_id !== "undefined") {
      newFilter["client_id"] = filter.client_id;
    }
    props.dispatch(
      salesBillingsActions.getComplete({
        token: Biscuit.get("token"),
        suffix: "",
        data: newFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setGetCompletePending(true);
    setClientsPending(true);
    setWalletsPending(true);
    setReady(true);
  }, []);
  useEffect(() => {
    if (walletsPending === false || _wallets.success === "") {
      return;
    }

    if (_wallets.success !== true) {
      console.log("Failed fetching wallets!");
    } else {
      setPagination({ ..._wallets.pagination });
    }
    setWalletsPending(false);
  }, [_wallets]);

  useEffect(() => {
    if (_clients.success === "" || !clientsPending) {
      return;
    }
    if (_clients.success === true) {
      let obj = {};
      let arr = [];
      arr.push({ name: "- " + t("all", null, "capital") + " -", value: "" });
      _clients.data.map((client) => {
        if (client.payment_settings.length > 0) {
          let set = false;
          client.payment_settings.map((setting) => {
            if (setting.stripe_secret_key.includes("sk_live")) {
              set = true;
            }
          });
          if (set) {
            arr.push({ name: client.id + " " + client.organization, value: client.id });
          }
          obj[client.id] = client.id + " " + client.organization;
        }
      });
      setClients(obj);
      setClientsArray(arr);
    }
    setClientsPending(false);
  }, [_clients]);

  useEffect(() => {
    if (_getComplete.success === "" || !getCompletePending) {
      return;
    }
    if (_getComplete.success === true) {
      setGetComplete(_getComplete.data);
    }
    setGetCompletePending(false);
  }, [_getComplete]);

  const loadNextPage = (page) => {
    //if (!pagination.has_next_page) return;

    setWalletsPending(true);

    let requestFilter = { ...filter };
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    requestFilter.limit = paginationLimit;
    requestFilter.page = page;
    requestFilter.complete = true;
    props.dispatch(paymentsActions.getTransactionsResetData());
    // fetch next page
    props.dispatch(
      paymentsActions.getTransactions({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setWalletsPending(true);
  };

  const filterChangedHandle = (filter) => {
    props.dispatch(paymentsActions.getTransactionsResetData());
    let requestFilter = { ...filter };
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }
    requestFilter.complete = true;
    props.dispatch(
      paymentsActions.getTransactions({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setWalletsPending(true);
    let begin = moment("1970-01-01").format("YYYY-MM-DD 23:59:59");
    let end = moment().format("YYYY-MM-DD 23:59:59");
    if (typeof filter.date_gte !== "undefined") {
      begin = filter.date_gte.replace("%20", " ");
    }
    if (typeof filter.date_lte !== "undefined") {
      end = filter.date_lte.replace("%20", " ");
    }
    let newFilter = {
      from: begin,
      to: end,
    };
    if (typeof filter.client_id !== "undefined") {
      newFilter["client_id"] = filter.client_id;
    }
    props.dispatch(
      salesBillingsActions.getComplete({
        token: Biscuit.get("token"),
        suffix: "",
        data: newFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setGetCompletePending(true);
    setFilter(filter);
  };

  const onSortChangedHandle = (ev) => {
    const el = ev.currentTarget;

    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          complete: true,
          page: 1,
        };
      }

      props.dispatch(
        paymentsActions.getTransactions({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setWalletsPending(true);
      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key, value) {
        key.classList.remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const onPrintClosingHandle = () => {
    printClosing(getComplete);
    return false;
  };

  const printClosing = (wallets) => {
    /*let output = <Abschluss
                    complete={getComplete}
                    clients={clientsArray}
                    begin={filter.begin_lte}
                    end={filter.date_lte}/>

            return (
                <div>
                    <ReactToPrint
                        trigger={() => {
                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                            // to the root node of the returned component as it will be overwritten.
                            return <a href="#">Print this out!</a>;
                        }}
                        content={() => this.componentRef}
                    />
                    <Abschluss
                        complete={getComplete}
                        clients={clientsArray}
                        begin={filter.begin_lte}
                        end={filter.date_lte} ref={el => (this.componentRef = el)} />
                </div>
            );
        }
*/
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
      var uA = navigator.userAgent;
      var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

      if (rE.exec(uA) != null) {
        rV = parseFloat(RegExp.$1);
      } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      /*check for IE 11*/
        rV = 11;
      }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    // Trigger print command to browser
    const printWindow = window.open("", "", "height=700,width=674");

    printWindow.document.body.innerHTML = "";
    printWindow.document.body.innerHTML = output;

    if (rV >= 10 || isChrome) {
      printWindow.document.close(); // necessary for IE >= 10
      printWindow.focus(); // necessary for IE >= 10*
      printWindow.print();
    } else {
      // e.g. Firefox
      setTimeout(() => {
        printWindow.print();
        printWindow.opener.focus();
        printWindow.close();
      }, 0);
    }
  };

  const submenuItems = [
    {
      name: t("transactions", null, "capital"),
      link: "finances/transactions",
      data_inb_val: t("transactions", null, "capital"),
      icon: "fi fi-dollar",
      isActive: false,
      isAccessible: isViewVisible("transactions", "finances"),
    },
    {
      name: t("sales_billings", null, "capital"),
      link: "finances/sales_billings",
      data_inb_val: t("sales_billings", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: isViewVisible("salesBillings", "finances"),
    },
    {
      name: t("payment_accounts", null, "capital"),
      link: "finances/payment_accounts",
      data_inb_val: t("payment_accounts", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: false && isViewVisible("paymentAccounts", "finances"),
    },
    {
      name: t("insurances", null, "capital"),
      link: "finances/insurances",
      data_inb_val: t("insurances", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
    {
      name: t("admin transactions", null, "capital"),
      link: "finances/admin_transactions",
      data_inb_val: t("admin transactions", null, "capital"),
      icon: "fi fi-list",
      isActive: true,
      isAccessible: true,
    },
    {
      name: t("invoices", null, "capital"),
      link: "invoices",
      data_inb_val: t("invoices", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
  ];

  let tabs = [
    {
      name: t("client", null, "capital"),
      smallWidth: 4,
      mediumWidth: 2,
      title: t("sort_by_${a}", { a: t("client") }, "capital"),
      canSort: true,
      sort: {
        direction: "asc",
        data_inb_val: "client_id",
      },
    },
    {
      name: t("order", null, "capital") + " / " + t("invoice"),
      smallWidth: 3,
      mediumWidth: 3,
      title: t("order", null, "capital") + " / " + t("invoice"),
      canSort: false,
    },
    {
      name: t("paid", null, "capital"),
      smallWidth: 4,
      mediumWidth: 2,
      title: t("sort_by_${a}", { a: t("payment date") }, "capital"),
      canSort: true,
      sort: {
        direction: "desc",
        data_inb_val: "payment_date",
      },
    },
    {
      name: t("fees", null, "capital") + " / " + t("invoice"),
      smallWidth: 4,
      mediumWidth: 2,
      title: t("fees", null, "capital") + " / " + t("invoice"),
      canSort: false,
    },
    {
      name: t("refunded", null, "capital"),
      mediumWidth: 2,
      smallWidth: 4,
      title: t("refunded", null, "capital"),
      canSort: false,
    },
    {
      name: t("payment type", null, "capital"),
      mediumWidth: 2,
      smallWidth: 1,
      title: t("payment type", null, "capital"),
      canSort: false,
    },
  ];

  const searchBarHandler = (ev) => {
    let query;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      query = "";
    }
    searchParams.delete("p_reference");
    if (query !== "") {
      searchParams.set("p_reference", query);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
    const minLength = 1;
    if (query.length >= minLength) {
      // work user search only for values bigger or equal to the minimum length
      let standardFilter = {
        sort: "name",
        direction: "asc",
        page: 1,
        complete: true,
        limit: paginationLimit,
        ...allUrlParams,
      };
      searchParams.delete("item");
      if (query !== "") {
        searchParams.set("p_reference", query);
      }
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
      let filterA = standardFilter;
      setResetFilter(true);
      setTimeout(function () {
        let diff = Number(moment().format("x")) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value === query) {
          // no changes after the last 700 ms -> user finished input -> start request
          filterChangedHandle({
            ...filterA,
            p_reference: query,
          });
        }
      }, 800);
    } else if (filter.p_reference !== undefined) {
      // reset filter when query was active
      let clone = { ...filter };
      delete clone.p_reference;
      filterChangedHandle(clone);
    } else {
      filterChangedHandle(filterA);
    }
    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };

  return (
    <>
      {clientsArray !== null && (
        <AdminTransactionsSidebar
          dispatch={props.dispatch}
          heading={t("admin transactions", null, "capital")}
          filterChangedHandle={filterChangedHandle}
          clients={clientsArray}
          clientsN={clients}
          resetFilter={resetFilter}
          setResetFilter={setResetFilter}
          setLocationName={setLocationName}
        />
      )}
      <div id="inb-c-main" className="columns">
        <InboomaSubmenu
          tabs={submenuItems}
          smallOnlyTitle={t("transactions", null, "capital")}
          searchbar={true}
          searchbarPlaceholder={t("payment_reference")}
          searchbarValue={
            allUrlParamsClone?.p_reference !== undefined ? allUrlParamsClone.p_reference : ""
          }
          searchbarHandler={searchBarHandler}
        />
        {typeof filter !== "undefined" && (
          <AdminTransactionsTopBar
            textLeft={t("saldo_from_${a}", {
              a: filter.date_lte
                ? moment(filter.date_lte).format("DD.MM.YYYY")
                : moment().format("DD.MM.YYYY"),
            })}
            refLabel={t("closing_print")}
            getComplete={getComplete}
            getCompletePending={getCompletePending}
            filter={filter}
            clients={clients}
            handler={onPrintClosingHandle}
          />
        )}
        <SortNav tabs={tabs} listStyle="tight" handler={onSortChangedHandle} />
        {!clientsPending &&
          _wallets?.data?.length > 0 &&
          !walletsPending &&
          typeof pagination !== "undefined" &&
          clients !== null &&
          ready && (
            <Paginator
              pagination={pagination}
              itemsCountPerPage={paginationLimit}
              // overwrite={_wallets?.data?.length}
              pageRangeDisplayed={5}
              upper={true}
              onChange={loadNextPage}
            />
          )}
        {!clientsPending && !walletsPending && ready && _wallets?.data?.length > 0 && (
          <>
            <div className="off-canvas-wrapper">
              <AdminTransactionsList
                wallets={_wallets.data}
                clients={clients}
                dispatch={props.dispatch}
              />
            </div>
            <AdminTransactionsTopBar
              textLeft={t("previous_saldo")}
              refLabel=""
              getComplete={getComplete}
              getCompletePending={getCompletePending}
              filter={filter}
              clients={clients}
              handler={onPrintClosingHandle}
            />
          </>
        )}
        {!clientsPending &&
          _wallets?.data?.length > 0 &&
          !walletsPending &&
          typeof pagination !== "undefined" &&
          clients !== null &&
          ready && (
            <Paginator
              pagination={pagination}
              itemsCountPerPage={paginationLimit}
              // overwrite={_wallets?.data?.length}
              pageRangeDisplayed={5}
              onChange={loadNextPage}
            />
          )}
        {_wallets?.data?.length < 1 && !walletsPending && !clientsPending && ready && (
          <>
            <div
              id="inb-app-collection-empty"
              className="inb-announcement"
              style={{ minHeight: "1150px" }}
            >
              <div className="inb-image-box">
                <img alt="No Data" src={"assets/img/no_data.svg"} />
              </div>
              <h3>{t("app_msg_collection_empty")}</h3>
              <p>{t("app_msg_collection_empty_body")}</p>
            </div>
          </>
        )}
        {walletsPending && <Loader mediumWidth={2} smallWidth={4} subLoaders={5} />}
      </div>
    </>
  );
};

export default AdminTransactionsView;
